// import React, { useState, useEffect } from "react";
// import "./WorkHistory.css";
// import HomeServices from "../../Services/HomeServices";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";

// const WorkHistory = () => {
//   const [loading, setLoading] = useState(false);
//   const [activeTab, setActiveTab] = useState("primary");
//   const [applicantId, setApplicantId] = useState("");
//   const [spouseId, setSpouseId] = useState("");
//   const [spouseExists, setSpouseExists] = useState(false);
//   const navigate = useNavigate();

//   // Primary Applicant State
//   const [primaryWork, setPrimaryWork] = useState({
//     workingLegallyInCanada: "",
//     primaryOccupationOrNOCcode: "",
//     havingAnyJOBOFFERorLMIAInCanada: "",
//     jobTitle: "",
//     jobFromDate: "",
//     jobToDate: "",
//     fullTimeOrPartTime: "",
//     hoursPerWeek: "",
//     NOCcode: "",
//     companyName: "",
//     companyAddressWithPostalCode: "",
//   });

//   // Spouse State
//   const [spouseWork, setSpouseWork] = useState({
//     workingLegallyInCanada: "",
//     primaryOccupationOrNOCcode: "",
//     havingAnyJOBOFFERorLMIAInCanada: "",
//     jobTitle: "",
//     jobFromDate: "",
//     jobToDate: "",
//     fullTimeOrPartTime: "",
//     hoursPerWeek: "",
//     NOCcode: "",
//     companyName: "",
//     companyAddressWithPostalCode: "",
//   });

//   const fetchApplicantData = async () => {
//     try {
//       setLoading(true);
//       const res = await HomeServices.getPrimariApplicantData();
//       console.log("Work history data response:", res);

//       if (res?.status && res?.data && res.data.length > 0) {
//         const primaryData = res.data[0]?.PrimaryApplicantData;

//         if (primaryData) {
//           // Set applicant ID
//           setApplicantId(primaryData._id);

//           // Check if spouse exists
//           if (primaryData.PrimaryApplicantSpouseData?._id) {
//             setSpouseExists(true);
//             setSpouseId(primaryData.PrimaryApplicantSpouseData._id);
//           }

//           // Load primary applicant work data
//           if (primaryData.workingLegallyInCanada !== undefined) {
//             setPrimaryWork({
//               workingLegallyInCanada: primaryData.workingLegallyInCanada || "",
//               primaryOccupationOrNOCcode:
//                 primaryData.primaryOccupationOrNOCcode || "",
//               havingAnyJOBOFFERorLMIAInCanada:
//                 primaryData.havingAnyJOBOFFERorLMIAInCanada || "",
//               jobTitle: primaryData.jobTitle || "",
//               jobFromDate: primaryData.jobFromDate
//                 ? formatDate(primaryData.jobFromDate)
//                 : "",
//               jobToDate: primaryData.jobToDate
//                 ? formatDate(primaryData.jobToDate)
//                 : "",
//               fullTimeOrPartTime: primaryData.fullTimeOrPartTime || "",
//               hoursPerWeek: primaryData.hoursPerWeek || "",
//               NOCcode: primaryData.NOCcode || "",
//               companyName: primaryData.companyName || "",
//               companyAddressWithPostalCode:
//                 primaryData.companyAddressWithPostalCode || "",
//             });
//           }

//           // Load spouse work data if exists
//           const spouseData = primaryData.PrimaryApplicantSpouseData;
//           if (spouseData) {
//             if (spouseData.workingLegallyInCanada !== undefined) {
//               setSpouseWork({
//                 workingLegallyInCanada: spouseData.workingLegallyInCanada || "",
//                 primaryOccupationOrNOCcode:
//                   spouseData.primaryOccupationOrNOCcode || "",
//                 havingAnyJOBOFFERorLMIAInCanada:
//                   spouseData.havingAnyJOBOFFERorLMIAInCanada || "",
//                 jobTitle: spouseData.jobTitle || "",
//                 jobFromDate: spouseData.jobFromDate
//                   ? formatDate(spouseData.jobFromDate)
//                   : "",
//                 jobToDate: spouseData.jobToDate
//                   ? formatDate(spouseData.jobToDate)
//                   : "",
//                 fullTimeOrPartTime: spouseData.fullTimeOrPartTime || "",
//                 hoursPerWeek: spouseData.hoursPerWeek || "",
//                 NOCcode: spouseData.NOCcode || "",
//                 companyName: spouseData.companyName || "",
//                 companyAddressWithPostalCode:
//                   spouseData.companyAddressWithPostalCode || "",
//               });
//             }
//           }

//           toast.success("Work history data loaded successfully!");
//         }
//       } else {
//         toast.error("No data available.");
//       }
//     } catch (error) {
//       console.log(error);
//       toast.error("Failed to load work history data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Helper function to format date from ISO to YYYY-MM-DD
//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return date.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     fetchApplicantData();
//   }, []);

//   // Handle Primary Applicant Changes
//   const handlePrimaryChange = (field, value) => {
//     setPrimaryWork((prev) => ({ ...prev, [field]: value }));
//   };

//   // Handle Spouse Changes
//   const handleSpouseChange = (field, value) => {
//     setSpouseWork((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Prepare primary applicant data
//     const primarySubmissionData = {
//       // Work history fields
//       workingLegallyInCanada: primaryWork.workingLegallyInCanada,
//       primaryOccupationOrNOCcode: primaryWork.primaryOccupationOrNOCcode,
//       havingAnyJOBOFFERorLMIAInCanada:
//         primaryWork.havingAnyJOBOFFERorLMIAInCanada,
//       jobTitle: primaryWork.jobTitle,
//       jobFromDate: primaryWork.jobFromDate,
//       jobToDate: primaryWork.jobToDate,
//       fullTimeOrPartTime: primaryWork.fullTimeOrPartTime,
//       hoursPerWeek: primaryWork.hoursPerWeek,
//       NOCcode: primaryWork.NOCcode,
//       companyName: primaryWork.companyName,
//       companyAddressWithPostalCode: primaryWork.companyAddressWithPostalCode,
//       isFinallySubmittedForm: true,
//     };

//     console.log("Primary Applicant Work Data:", primarySubmissionData);
//     // return;
//     try {
//       setLoading(true);

//       // Update primary applicant data
//       const primaryRes = await HomeServices?.updatePrimaryApplicantData(
//         primarySubmissionData,
//         applicantId,
//       );

//       console.log("Primary applicant response:", primaryRes);

//       if (primaryRes?.status) {
//         toast.success("Primary applicant work history updated successfully!");
//       } else {
//         toast.error(
//           primaryRes?.message || "Failed to update primary applicant data",
//         );
//       }

//       // If spouse exists, update spouse data
//       if (spouseExists && spouseId) {
//         const spouseSubmissionData = {
//           // Work history fields
//           workingLegallyInCanada: spouseWork.workingLegallyInCanada,
//           primaryOccupationOrNOCcode: spouseWork.primaryOccupationOrNOCcode,
//           havingAnyJOBOFFERorLMIAInCanada:
//             spouseWork.havingAnyJOBOFFERorLMIAInCanada,
//           jobTitle: spouseWork.jobTitle,
//           jobFromDate: spouseWork.jobFromDate,
//           jobToDate: spouseWork.jobToDate,
//           fullTimeOrPartTime: spouseWork.fullTimeOrPartTime,
//           hoursPerWeek: spouseWork.hoursPerWeek,
//           NOCcode: spouseWork.NOCcode,
//           companyName: spouseWork.companyName,
//           companyAddressWithPostalCode: spouseWork.companyAddressWithPostalCode,

//           // Primary applicant ID for spouse update
//           primaryApplicantId: applicantId,
//         };

//         console.log("Spouse Work Data:", spouseSubmissionData);

//         const spouseRes = await HomeServices?.updatePrimaryApplicantSpouseData(
//           spouseSubmissionData,
//           spouseId,
//         );

//         console.log("Spouse response:", spouseRes);

//         if (spouseRes?.status) {
//           toast.success("Spouse work history updated successfully!");
//         } else {
//           toast.error(spouseRes?.message || "Failed to update spouse data");
//         }
//       }

//       // Navigate to next step
//       navigate("/");
//     } catch (error) {
//       console.log(error);
//       toast.error("Failed to submit work history data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Render form based on active tab
//   const renderForm = () => {
//     const isPrimary = activeTab === "primary";

//     const workData = isPrimary ? primaryWork : spouseWork;
//     const handleChange = isPrimary ? handlePrimaryChange : handleSpouseChange;

//     return (
//       <div className="tab-content">
//         <div className="form-columns">
//           <div className="form-column">
//             <div className="form-group">
//               <label htmlFor="workingLegallyInCanada">
//                 Working Legally in Canada?
//               </label>
//               <select
//                 id="workingLegallyInCanada"
//                 value={workData.workingLegallyInCanada}
//                 onChange={(e) =>
//                   handleChange("workingLegallyInCanada", e.target.value)
//                 }
//               >
//                 <option value="">Select option</option>
//                 <option value="yes">Yes</option>
//                 <option value="no">No</option>
//               </select>
//             </div>

//             <div className="form-group">
//               <label htmlFor="primaryOccupationOrNOCcode">
//                 Primary Occupation (NOC code)
//               </label>
//               <input
//                 type="text"
//                 id="primaryOccupationOrNOCcode"
//                 value={workData.primaryOccupationOrNOCcode}
//                 onChange={(e) =>
//                   handleChange("primaryOccupationOrNOCcode", e.target.value)
//                 }
//                 placeholder="e.g., Software Engineer"
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="havingAnyJOBOFFERorLMIAInCanada">
//                 Do you have any JOB OFFER (LMIA) in Canada?
//               </label>
//               <select
//                 id="havingAnyJOBOFFERorLMIAInCanada"
//                 value={workData.havingAnyJOBOFFERorLMIAInCanada}
//                 onChange={(e) =>
//                   handleChange(
//                     "havingAnyJOBOFFERorLMIAInCanada",
//                     e.target.value,
//                   )
//                 }
//               >
//                 <option value="">Select option</option>
//                 <option value="yes">Yes</option>
//                 <option value="no">No</option>
//               </select>
//             </div>

//             <div className="form-group">
//               <label htmlFor="jobTitle">Job Title</label>
//               <input
//                 type="text"
//                 id="jobTitle"
//                 value={workData.jobTitle}
//                 onChange={(e) => handleChange("jobTitle", e.target.value)}
//                 placeholder="Enter job title"
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="jobFromDate">From Date</label>
//               <input
//                 type="date"
//                 id="jobFromDate"
//                 value={workData.jobFromDate}
//                 onChange={(e) => handleChange("jobFromDate", e.target.value)}
//               />
//             </div>
//           </div>

//           <div className="form-column">
//             <div className="form-group">
//               <label htmlFor="jobToDate">To Date</label>
//               <input
//                 type="date"
//                 id="jobToDate"
//                 value={workData.jobToDate}
//                 onChange={(e) => handleChange("jobToDate", e.target.value)}
//               />
//             </div>

//             <div className="form-group">
//               <label>Full Time/Part Time</label>
//               <div className="radio-group">
//                 <label className="radio-label">
//                   <input
//                     type="radio"
//                     name="fullTimeOrPartTime"
//                     value="full"
//                     checked={workData.fullTimeOrPartTime === "full"}
//                     onChange={(e) =>
//                       handleChange("fullTimeOrPartTime", e.target.value)
//                     }
//                   />
//                   <span className="radio-custom"></span>
//                   Full Time
//                 </label>
//                 <label className="radio-label">
//                   <input
//                     type="radio"
//                     name="fullTimeOrPartTime"
//                     value="part"
//                     checked={workData.fullTimeOrPartTime === "part"}
//                     onChange={(e) =>
//                       handleChange("fullTimeOrPartTime", e.target.value)
//                     }
//                   />
//                   <span className="radio-custom"></span>
//                   Part Time
//                 </label>
//               </div>
//             </div>

//             <div className="form-group">
//               <label htmlFor="hoursPerWeek">Hours per week</label>
//               <input
//                 type="text"
//                 id="hoursPerWeek"
//                 value={workData.hoursPerWeek}
//                 onChange={(e) => handleChange("hoursPerWeek", e.target.value)}
//                 placeholder="e.g., 40"
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="NOCcode">NOC Code (If Known)</label>
//               <input
//                 type="text"
//                 id="NOCcode"
//                 value={workData.NOCcode}
//                 onChange={(e) => handleChange("NOCcode", e.target.value)}
//                 placeholder="e.g., 2173"
//               />
//             </div>
//           </div>
//         </div>

//         <div className="full-width-section">
//           <div className="form-group">
//             <label htmlFor="companyName">Company Name</label>
//             <input
//               type="text"
//               id="companyName"
//               value={workData.companyName}
//               onChange={(e) => handleChange("companyName", e.target.value)}
//               placeholder="Enter company name"
//               className="full-width-input"
//             />
//           </div>

//           <div className="form-group">
//             <label htmlFor="companyAddressWithPostalCode">
//               Company Full Address With Postal Code
//             </label>
//             <textarea
//               id="companyAddressWithPostalCode"
//               value={workData.companyAddressWithPostalCode}
//               onChange={(e) =>
//                 handleChange("companyAddressWithPostalCode", e.target.value)
//               }
//               placeholder="Enter complete company address including postal code"
//               rows="3"
//               className="full-width-textarea"
//             />
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="work-container">
//       <div className="form-header">
//         <h1>Work History</h1>
//         <p>
//           Please provide work history information for the primary applicant and
//           spouse.
//         </p>
//       </div>

//       {loading && (
//         <div className="loading-indicator">
//           <p>Loading work history data...</p>
//         </div>
//       )}

//       <div className="tab-navigation">
//         <button
//           className={`tab-btn ${activeTab === "primary" ? "active" : ""}`}
//           onClick={() => setActiveTab("primary")}
//         >
//           Primary Applicant
//         </button>
//         {spouseExists && (
//           <button
//             className={`tab-btn ${activeTab === "spouse" ? "active" : ""}`}
//             onClick={() => setActiveTab("spouse")}
//           >
//             Spouse
//           </button>
//         )}
//       </div>

//       <form onSubmit={handleSubmit}>
//         {renderForm()}

//         <div className="form-footer" style={{ display: "flex", gap: "20px" }}>
//           <button
//             onClick={() => {
//               navigate(-1);
//             }}
//             type="button"
//             className="submit-btn"
//             disabled={loading}
//           >
//             Back
//           </button>
//           <button
//             type="submit"
//             className="submit-btn"
//             disabled={loading}
//             style={{ display: "flex", flexDirection: "column" }}
//           >
//             {loading ? "Saving..." : "Submit"}
//             <small style={{ color: "#db1507", fontWeight: "500" }}>
//               (Once submitted, it cannot be reversed)
//             </small>
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default WorkHistory;

import React, { useState, useEffect } from "react";
import "./WorkHistory.css";
import HomeServices from "../../Services/HomeServices";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const WorkHistory = () => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("primary");
  const [applicantId, setApplicantId] = useState("");
  const [spouseId, setSpouseId] = useState("");
  const [spouseExists, setSpouseExists] = useState(false);
  const navigate = useNavigate();

  // Primary Applicant State - Separate fields
  const [primaryWorkFields, setPrimaryWorkFields] = useState({
    workingLegallyInCanada: "",
    primaryOccupationOrNOCcode: "",
    havingAnyJOBOFFERorLMIAInCanada: "",
  });

  // Primary Applicant Work History Array
  const [primaryWorkHistory, setPrimaryWorkHistory] = useState([
    {
      jobTitle: "",
      jobFromDate: "",
      jobToDate: "",
      fullTimeOrPartTime: "",
      hoursPerWeek: "",
      NOCcode: "",
      companyName: "",
      companyAddressWithPostalCode: "",
    },
  ]);

  // Spouse State - Separate fields
  const [spouseWorkFields, setSpouseWorkFields] = useState({
    workingLegallyInCanada: "",
    primaryOccupationOrNOCcode: "",
    havingAnyJOBOFFERorLMIAInCanada: "",
  });

  // Spouse Work History Array
  const [spouseWorkHistory, setSpouseWorkHistory] = useState([
    {
      jobTitle: "",
      jobFromDate: "",
      jobToDate: "",
      fullTimeOrPartTime: "",
      hoursPerWeek: "",
      NOCcode: "",
      companyName: "",
      companyAddressWithPostalCode: "",
    },
  ]);

  const fetchApplicantData = async () => {
    try {
      setLoading(true);
      const res = await HomeServices.getPrimariApplicantData();
      console.log("Work history data response:", res);

      if (res?.status && res?.data && res.data.length > 0) {
        const primaryData = res.data[0]?.PrimaryApplicantData;

        if (primaryData) {
          // Set applicant ID
          setApplicantId(primaryData._id);

          // Check if spouse exists
          if (primaryData.PrimaryApplicantSpouseData?._id) {
            setSpouseExists(true);
            setSpouseId(primaryData.PrimaryApplicantSpouseData._id);
          }

          // Load primary applicant work fields
          if (primaryData.workingLegallyInCanada !== undefined) {
            setPrimaryWorkFields({
              workingLegallyInCanada: primaryData.workingLegallyInCanada || "",
              primaryOccupationOrNOCcode:
                primaryData.primaryOccupationOrNOCcode || "",
              havingAnyJOBOFFERorLMIAInCanada:
                primaryData.havingAnyJOBOFFERorLMIAInCanada || "",
            });
          }

          // Load primary applicant work history array
          if (primaryData.workHistory && primaryData.workHistory.length > 0) {
            setPrimaryWorkHistory(
              primaryData.workHistory.map((work) => ({
                jobTitle: work.jobTitle || "",
                jobFromDate: work.jobFromDate
                  ? formatDate(work.jobFromDate)
                  : "",
                jobToDate: work.jobToDate ? formatDate(work.jobToDate) : "",
                fullTimeOrPartTime: work.fullTimeOrPartTime || "",
                hoursPerWeek: work.hoursPerWeek || "",
                NOCcode: work.NOCcode || "",
                companyName: work.companyName || "",
                companyAddressWithPostalCode:
                  work.companyAddressWithPostalCode || "",
              })),
            );
          }

          // Load spouse data if exists
          const spouseData = primaryData.PrimaryApplicantSpouseData;
          if (spouseData) {
            // Load spouse work fields
            if (spouseData.workingLegallyInCanada !== undefined) {
              setSpouseWorkFields({
                workingLegallyInCanada: spouseData.workingLegallyInCanada || "",
                primaryOccupationOrNOCcode:
                  spouseData.primaryOccupationOrNOCcode || "",
                havingAnyJOBOFFERorLMIAInCanada:
                  spouseData.havingAnyJOBOFFERorLMIAInCanada || "",
              });
            }

            // Load spouse work history array
            if (spouseData.workHistory && spouseData.workHistory.length > 0) {
              setSpouseWorkHistory(
                spouseData.workHistory.map((work) => ({
                  jobTitle: work.jobTitle || "",
                  jobFromDate: work.jobFromDate
                    ? formatDate(work.jobFromDate)
                    : "",
                  jobToDate: work.jobToDate ? formatDate(work.jobToDate) : "",
                  fullTimeOrPartTime: work.fullTimeOrPartTime || "",
                  hoursPerWeek: work.hoursPerWeek || "",
                  NOCcode: work.NOCcode || "",
                  companyName: work.companyName || "",
                  companyAddressWithPostalCode:
                    work.companyAddressWithPostalCode || "",
                })),
              );
            }
          }

          toast.success("Work history data loaded successfully!");
        }
      } else {
        toast.error("No data available.");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to load work history data");
    } finally {
      setLoading(false);
    }
  };

  // Helper function to format date from ISO to YYYY-MM-DD
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  useEffect(() => {
    fetchApplicantData();
  }, []);

  // Handle Primary Work Fields Changes
  const handlePrimaryFieldChange = (field, value) => {
    setPrimaryWorkFields((prev) => ({ ...prev, [field]: value }));
  };

  // Handle Primary Work History Changes
  const handlePrimaryWorkHistoryChange = (index, field, value) => {
    const updatedHistory = [...primaryWorkHistory];
    updatedHistory[index][field] = value;
    setPrimaryWorkHistory(updatedHistory);
  };

  const addPrimaryWorkEntry = () => {
    setPrimaryWorkHistory([
      ...primaryWorkHistory,
      {
        jobTitle: "",
        jobFromDate: "",
        jobToDate: "",
        fullTimeOrPartTime: "",
        hoursPerWeek: "",
        NOCcode: "",
        companyName: "",
        companyAddressWithPostalCode: "",
      },
    ]);
  };

  const removePrimaryWorkEntry = (index) => {
    if (primaryWorkHistory.length > 1) {
      const updatedHistory = primaryWorkHistory.filter((_, i) => i !== index);
      setPrimaryWorkHistory(updatedHistory);
    } else {
      toast.error("At least one work history entry is required");
    }
  };

  // Handle Spouse Work Fields Changes
  const handleSpouseFieldChange = (field, value) => {
    setSpouseWorkFields((prev) => ({ ...prev, [field]: value }));
  };

  // Handle Spouse Work History Changes
  const handleSpouseWorkHistoryChange = (index, field, value) => {
    const updatedHistory = [...spouseWorkHistory];
    updatedHistory[index][field] = value;
    setSpouseWorkHistory(updatedHistory);
  };

  const addSpouseWorkEntry = () => {
    setSpouseWorkHistory([
      ...spouseWorkHistory,
      {
        jobTitle: "",
        jobFromDate: "",
        jobToDate: "",
        fullTimeOrPartTime: "",
        hoursPerWeek: "",
        NOCcode: "",
        companyName: "",
        companyAddressWithPostalCode: "",
      },
    ]);
  };

  const removeSpouseWorkEntry = (index) => {
    if (spouseWorkHistory.length > 1) {
      const updatedHistory = spouseWorkHistory.filter((_, i) => i !== index);
      setSpouseWorkHistory(updatedHistory);
    } else {
      toast.error("At least one work history entry is required");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare primary applicant data
    const primarySubmissionData = {
      // Work fields
      workingLegallyInCanada: primaryWorkFields.workingLegallyInCanada,
      primaryOccupationOrNOCcode: primaryWorkFields.primaryOccupationOrNOCcode,
      havingAnyJOBOFFERorLMIAInCanada:
        primaryWorkFields.havingAnyJOBOFFERorLMIAInCanada,

      // Work History array
      workHistory: primaryWorkHistory.map((work) => ({
        jobTitle: work.jobTitle || "",
        jobFromDate: work.jobFromDate || null,
        jobToDate: work.jobToDate || null,
        fullTimeOrPartTime: work.fullTimeOrPartTime || "",
        hoursPerWeek: work.hoursPerWeek || "",
        NOCcode: work.NOCcode || "",
        companyName: work.companyName || "",
        companyAddressWithPostalCode: work.companyAddressWithPostalCode || "",
      })),

      isFinallySubmittedForm: true,
    };

    console.log("Primary Applicant Work Data:", primarySubmissionData);

    try {
      setLoading(true);

      // Update primary applicant data
      const primaryRes = await HomeServices?.updatePrimaryApplicantData(
        primarySubmissionData,
        applicantId,
      );

      console.log("Primary applicant response:", primaryRes);

      if (primaryRes?.status) {
        toast.success("Primary applicant work history updated successfully!");
      } else {
        toast.error(
          primaryRes?.message || "Failed to update primary applicant data",
        );
      }

      // If spouse exists, update spouse data
      if (spouseExists && spouseId) {
        const spouseSubmissionData = {
          // Work fields
          workingLegallyInCanada: spouseWorkFields.workingLegallyInCanada,
          primaryOccupationOrNOCcode:
            spouseWorkFields.primaryOccupationOrNOCcode,
          havingAnyJOBOFFERorLMIAInCanada:
            spouseWorkFields.havingAnyJOBOFFERorLMIAInCanada,

          // Work History array
          workHistory: spouseWorkHistory.map((work) => ({
            jobTitle: work.jobTitle || "",
            jobFromDate: work.jobFromDate || null,
            jobToDate: work.jobToDate || null,
            fullTimeOrPartTime: work.fullTimeOrPartTime || "",
            hoursPerWeek: work.hoursPerWeek || "",
            NOCcode: work.NOCcode || "",
            companyName: work.companyName || "",
            companyAddressWithPostalCode:
              work.companyAddressWithPostalCode || "",
          })),

          // Primary applicant ID for spouse update
          primaryApplicantId: applicantId,
        };

        console.log("Spouse Work Data:", spouseSubmissionData);

        const spouseRes = await HomeServices?.updatePrimaryApplicantSpouseData(
          spouseSubmissionData,
          spouseId,
        );

        console.log("Spouse response:", spouseRes);

        if (spouseRes?.status) {
          toast.success("Spouse work history updated successfully!");
        } else {
          toast.error(spouseRes?.message || "Failed to update spouse data");
        }
      }

      // Navigate to next step
      navigate("/");
    } catch (error) {
      console.log(error);
      toast.error("Failed to submit work history data");
    } finally {
      setLoading(false);
    }
  };

  // Render work history section
  const renderWorkHistory = (isPrimary) => {
    const workHistory = isPrimary ? primaryWorkHistory : spouseWorkHistory;
    const handleWorkHistoryChange = isPrimary
      ? handlePrimaryWorkHistoryChange
      : handleSpouseWorkHistoryChange;
    const addEntry = isPrimary ? addPrimaryWorkEntry : addSpouseWorkEntry;
    const removeEntry = isPrimary
      ? removePrimaryWorkEntry
      : removeSpouseWorkEntry;

    return (
      <div className="work-history-section">
        <h2 className="section-title">Work History</h2>
        {workHistory.map((work, index) => (
          <div key={index} className="work-entry">
            <div
              className="entry-header"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <h3>Work Experience #{index + 1}</h3>
              {workHistory.length > 1 && (
                <button
                  type="button"
                  className="remove-btn"
                  onClick={() => removeEntry(index)}
                >
                  Remove
                </button>
              )}
            </div>
            <div className="form-columns">
              <div className="form-column">
                <div className="form-group">
                  <label htmlFor={`jobTitle-${isPrimary}-${index}`}>
                    Job Title
                  </label>
                  <input
                    type="text"
                    id={`jobTitle-${isPrimary}-${index}`}
                    value={work.jobTitle}
                    onChange={(e) =>
                      handleWorkHistoryChange(index, "jobTitle", e.target.value)
                    }
                    placeholder="Enter job title"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`jobFromDate-${isPrimary}-${index}`}>
                    From Date
                  </label>
                  <input
                    type="date"
                    id={`jobFromDate-${isPrimary}-${index}`}
                    value={work.jobFromDate}
                    onChange={(e) =>
                      handleWorkHistoryChange(
                        index,
                        "jobFromDate",
                        e.target.value,
                      )
                    }
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`jobToDate-${isPrimary}-${index}`}>
                    To Date
                  </label>
                  <input
                    type="date"
                    id={`jobToDate-${isPrimary}-${index}`}
                    value={work.jobToDate}
                    onChange={(e) =>
                      handleWorkHistoryChange(
                        index,
                        "jobToDate",
                        e.target.value,
                      )
                    }
                  />
                </div>
              </div>

              <div className="form-column">
                <div className="form-group">
                  <label>Full Time/Part Time</label>
                  <div className="radio-group">
                    <label className="radio-label">
                      <input
                        type="radio"
                        name={`fullTimeOrPartTime-${isPrimary}-${index}`}
                        value="full"
                        checked={work.fullTimeOrPartTime === "full"}
                        onChange={(e) =>
                          handleWorkHistoryChange(
                            index,
                            "fullTimeOrPartTime",
                            e.target.value,
                          )
                        }
                      />
                      <span className="radio-custom"></span>
                      Full Time
                    </label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        name={`fullTimeOrPartTime-${isPrimary}-${index}`}
                        value="part"
                        checked={work.fullTimeOrPartTime === "part"}
                        onChange={(e) =>
                          handleWorkHistoryChange(
                            index,
                            "fullTimeOrPartTime",
                            e.target.value,
                          )
                        }
                      />
                      <span className="radio-custom"></span>
                      Part Time
                    </label>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor={`hoursPerWeek-${isPrimary}-${index}`}>
                    Hours per week
                  </label>
                  <input
                    type="text"
                    id={`hoursPerWeek-${isPrimary}-${index}`}
                    value={work.hoursPerWeek}
                    onChange={(e) =>
                      handleWorkHistoryChange(
                        index,
                        "hoursPerWeek",
                        e.target.value,
                      )
                    }
                    placeholder="e.g., 40"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`NOCcode-${isPrimary}-${index}`}>
                    NOC Code (If Known)
                  </label>
                  <input
                    type="text"
                    id={`NOCcode-${isPrimary}-${index}`}
                    value={work.NOCcode}
                    onChange={(e) =>
                      handleWorkHistoryChange(index, "NOCcode", e.target.value)
                    }
                    placeholder="e.g., 2173"
                  />
                </div>
              </div>
            </div>

            <div className="full-width-section">
              <div className="form-group">
                <label htmlFor={`companyName-${isPrimary}-${index}`}>
                  Company Name
                </label>
                <input
                  type="text"
                  id={`companyName-${isPrimary}-${index}`}
                  value={work.companyName}
                  onChange={(e) =>
                    handleWorkHistoryChange(
                      index,
                      "companyName",
                      e.target.value,
                    )
                  }
                  placeholder="Enter company name"
                  className="full-width-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`companyAddress-${isPrimary}-${index}`}>
                  Company Full Address With Postal Code
                </label>
                <textarea
                  id={`companyAddress-${isPrimary}-${index}`}
                  value={work.companyAddressWithPostalCode}
                  onChange={(e) =>
                    handleWorkHistoryChange(
                      index,
                      "companyAddressWithPostalCode",
                      e.target.value,
                    )
                  }
                  placeholder="Enter complete company address including postal code"
                  rows="3"
                  className="full-width-textarea"
                />
              </div>
            </div>
            {index < workHistory.length - 1 && <hr className="entry-divider" />}
          </div>
        ))}
        <button type="button" className="add-more-btn" onClick={addEntry}>
          + Add More Work Experience
        </button>
      </div>
    );
  };

  // Render form based on active tab
  const renderForm = () => {
    const isPrimary = activeTab === "primary";

    const workFields = isPrimary ? primaryWorkFields : spouseWorkFields;
    const handleFieldChange = isPrimary
      ? handlePrimaryFieldChange
      : handleSpouseFieldChange;

    return (
      <div className="tab-content">
        {/* Static Fields Section */}
        <h2 className="section-title">Employment Status</h2>
        <div className="form-columns">
          <div className="form-column">
            <div className="form-group">
              <label htmlFor="workingLegallyInCanada">
                Working Legally in Canada?
              </label>
              <select
                id="workingLegallyInCanada"
                value={workFields.workingLegallyInCanada}
                onChange={(e) =>
                  handleFieldChange("workingLegallyInCanada", e.target.value)
                }
              >
                <option value="">Select option</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
          </div>

          <div className="form-column">
            <div className="form-group">
              <label htmlFor="primaryOccupationOrNOCcode">
                Primary Occupation (NOC code)
              </label>
              <input
                type="text"
                id="primaryOccupationOrNOCcode"
                value={workFields.primaryOccupationOrNOCcode}
                onChange={(e) =>
                  handleFieldChange(
                    "primaryOccupationOrNOCcode",
                    e.target.value,
                  )
                }
                placeholder="e.g., Software Engineer"
              />
            </div>
          </div>
        </div>

        <div className="form-columns">
          <div className="form-column">
            <div className="form-group col-6">
              <label htmlFor="havingAnyJOBOFFERorLMIAInCanada">
                Do you have any JOB OFFER (LMIA) in Canada?
              </label>
              <select
                id="havingAnyJOBOFFERorLMIAInCanada"
                value={workFields.havingAnyJOBOFFERorLMIAInCanada}
                onChange={(e) =>
                  handleFieldChange(
                    "havingAnyJOBOFFERorLMIAInCanada",
                    e.target.value,
                  )
                }
              >
                <option value="">Select option</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
          </div>
        </div>

        {/* Work History Array Section */}
        {renderWorkHistory(isPrimary)}
      </div>
    );
  };

  return (
    <div className="work-container">
      <div className="form-header">
        <h1>Work History</h1>
        <p>
          Please provide work history information for the primary applicant and
          spouse.
        </p>
      </div>

      {loading && (
        <div className="loading-indicator">
          <p>Loading work history data...</p>
        </div>
      )}

      <div className="tab-navigation">
        <button
          className={`tab-btn ${activeTab === "primary" ? "active" : ""}`}
          onClick={() => setActiveTab("primary")}
        >
          Primary Applicant
        </button>
        {spouseExists && (
          <button
            className={`tab-btn ${activeTab === "spouse" ? "active" : ""}`}
            onClick={() => setActiveTab("spouse")}
          >
            Spouse
          </button>
        )}
      </div>

      <form onSubmit={handleSubmit}>
        {renderForm()}

        <div className="form-footer" style={{ display: "flex", gap: "20px" }}>
          <button
            onClick={() => {
              navigate(-1);
            }}
            type="button"
            className="submit-btn"
            disabled={loading}
          >
            Back
          </button>
          <button
            type="submit"
            className="submit-btn"
            disabled={loading}
            style={{ display: "flex", flexDirection: "column" }}
          >
            {loading ? "Saving..." : "Submit"}
            <small style={{ color: "#db1507", fontWeight: "500" }}>
              (Once submitted, it cannot be reversed)
            </small>
          </button>
        </div>
      </form>
    </div>
  );
};

export default WorkHistory;
